import store from '@/store'

export default {
  requireUser (to, from, next) {
    if (store.state.isLogged === true) {
      next()
    } else {
      next('/uiw-admin')
    }
  }
}
